import { orchestrator } from 'satcheljs';
import addReadWriteRecipients from '../actions/addReadWriteRecipients';
import getReadWriteRecipientViewState from 'owa-recipient-common/lib/utils/getReadWriteRecipientViewState';
import addRecipientsToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientsToRecipientWell';
import resetRecipientWell from '../actions/resetRecipientWell';
import showHideFindResult from '../actions/showHideFindResult';
import resolveAllUnresolvedRecipients from '../actions/resolveAllUnresolvedRecipients';
import addToCache from 'owa-recipient-cache/lib/actions/addToCache';
import onRecipientsChanged from '../actions/onRecipientsChanged';

export default orchestrator(addReadWriteRecipients, async actionMessage => {
    const { recipientWell, recipientData, resetFindResult } = actionMessage;
    let recipientsToAdd = [];

    for (let entry of recipientData) {
        let newRecipient = getReadWriteRecipientViewState(
            entry.newPersona,
            entry.isValid,
            entry.newEmailAddress
        );

        recipientsToAdd.push(newRecipient);
    }

    // Adding recipients in bulk
    addRecipientsToRecipientWell(recipientsToAdd, recipientWell);

    for (let newRecipient of recipientsToAdd) {
        if (resetFindResult && recipientWell) {
            resetRecipientWell(recipientWell);
            // Upon resolved, reset the Find Result
            showHideFindResult(
                recipientWell,
                true /**shouldShowFindResult */,
                true /* shouldClearFindResult */
            );

            // If we're in force resolve state, continue resolving unresolved recipients.
            if (recipientWell.inForceResolve) {
                await resolveAllUnresolvedRecipients(recipientWell, recipientWell.recipients);
            }
        }

        if (newRecipient.isValid) {
            // Backfill the cache with new personas
            addToCache([newRecipient.persona]);
        }
    }

    onRecipientsChanged(recipientWell, recipientData);
});
